import ".././styles/Layout.css";
import ".././styles/styles.css";
import pccmlogo from ".././assets/pccm_logo.png";
import { Outlet, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from ".././components/Footer.js";
import CTA from ".././components/CTA.js";
import AdvertiseBanner from ".././components/AdvertiseBanner.js";
function Layout() {
    return (
        <>
            
            <Navbar/>
            <Outlet />
            <AdvertiseBanner />
            <CTA />
            <Footer />
        </>
    );
}

export default Layout;